// extracted by mini-css-extract-plugin
export default {"root":"PageAction_root__QmFN9","cardsEventDetail":"PageAction_cardsEventDetail__vFmsd","box":"PageAction_box__08ikt","buttonsContainer":"PageAction_buttonsContainer__VcjRJ"};